import React from 'react'
import { connect } from 'react-redux'
import List from './List'
import Tiles from './Tiles'

export default connect(
  state => ({ viewSelected: state.signupForm.viewSelected }),
  null
)(({ viewSelected }) => viewSelected === 'list' ? <List /> : <Tiles />)